import React from 'react'
import isFunction from 'lodash/isFunction'
import { AnyReactComponentType } from './types'

export type ReactNodeOrNull = React.ReactNode | null

export default function renderIf(
  condition: boolean,
  componentToRender: AnyReactComponentType | React.ReactNode,
  defaultComponent: AnyReactComponentType | ReactNodeOrNull = null
): ReactNodeOrNull {
  if (!condition)
    return isFunction(defaultComponent)
      ? defaultComponent({})
      : (defaultComponent as ReactNodeOrNull)
  return isFunction(componentToRender)
    ? componentToRender({})
    : (componentToRender as ReactNodeOrNull)
}
